import { useEffect, useState, useRef } from "react"
import { animate } from "motion/react"
import { motion } from "motion/react"

interface AnimatedNumberProps {
  value: number
  decimals?: number
  prefix?: string
  suffix?: string
  className?: string
}

export function AnimatedNumber({
  value,
  decimals = 2,
  prefix = "",
  suffix = "",
  className = "",
}: AnimatedNumberProps) {
  const [displayValue, setDisplayValue] = useState(value)
  const currentValueRef = useRef(value)

  useEffect(() => {
    if (Math.abs(currentValueRef.current - value) > 0.01) {
      const startValue = currentValueRef.current
      
      const controls = animate(startValue, value, {
        duration: 0.6,
        ease: "easeOut",
        onUpdate: (latest) => {
          setDisplayValue(latest)
          currentValueRef.current = latest
        },
      })

      return () => controls.stop()
    }
  }, [value])

  const formattedValue = displayValue.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })

  return (
    <motion.span
      className={className}
      key={`${value}-${formattedValue}`}
      initial={{ scale: 1.05, opacity: 0.8 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.2 }}
    >
      {prefix}
      {formattedValue}
      {suffix}
    </motion.span>
  )
}
